<template>
  <div class="print-postCo-container">
    <table>
      <tbody class="print-postCo">
        <tr class="item-postCo noBreak" v-for="(row,index) in printMailData" :key="index">
          <td v-for="(column,index) in row" :key="index">
            <div class="data-container">
              <div v-if="column.address" class="sender">
                <div>
                  <span>407</span>
                  <span>台南市中西區西門路二段263號</span>
                </div>
                <div>
                  <span>金牌王國</span>
                  <span>096702232</span>
                </div>
              </div>
              <div v-if="column.address" class="recipient">
                <div class="recipient-address">
                  <div>{{ column.postal_code }}</div>
                  <div>
                    <div>{{ column.address }}</div>
                    <div class="recipient-name">
                      <div>{{ column.full_name }}</div>
                      <div>{{ column.phone }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "admin_printPostCoMailingInfo",
  props: {
    printMailData: {
      type: Array
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.print-postCo-container {
  table {
    padding: 30px 20px;
    width: 100%;
  }
  .print-postCo {
    .item-postCo {
      padding: 10px;
    }
  }
  td {
    width: 50vw;
    border: 1px solid #000;
    padding: 15px;
  }
  .data-container {
    width: 50vw;
  }
  .sender {
    * {
      font-size: 20px;
    }
    margin-bottom: 15px;
    span {
      display: inline-block;
      margin-right: 30px;
    }
  }
  .recipient {
    * {
      font-size: 25px;
    }
    .recipient-address {
      margin-left: 10%;
      div:first-child {
        margin-right: 30px;
      }
    }
    .recipient-name {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }
}

@media print {
  .print-postCo-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
  .noBreak {
    break-inside: avoid;
  }
}
</style>
